import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InventoryStocktakingQuantityCannotBeLessThanZero extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.inventory.item.validation.stocktaking-quantity.cannot-be-less-than-zero');
    }
}
